import { Card, Divider, Flex, Skeleton, Text } from '@servicetitan/anvil2';
import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { useSearchStore } from '../../shared';
import { SearchResult } from './search-result';
import * as Styles from './search-results.module.less';

export const SearchResults = observer(() => {
    const searchStore = useSearchStore();

    if (!searchStore.isSearchResultsVisible) {
        return null;
    }
    return (
        <Card
            className={Styles.container}
            padding="small"
            data-cy="ish-search-results"
            alignItems="stretch"
        >
            <Flex direction="column" grow={1}>
                {searchStore.isLoading ? (
                    <Flex direction="column" gap={4} data-cy="ish-search-results-loading">
                        <Skeleton.Text style={{ width: '50%' }} />
                        <Skeleton.Text style={{ width: '30%' }} />
                    </Flex>
                ) : searchStore.isEmptySearchResults ? (
                    <Flex direction="row" alignItems="center" gap={2}>
                        <Divider flexGrow={1} />
                        <Text
                            variant="eyebrow"
                            className={Styles.noResults}
                            data-cy="ish-search-results-empty"
                        >
                            No support cases
                        </Text>
                        <Divider flexGrow={1} />
                    </Flex>
                ) : (
                    <Fragment>
                        {searchStore.cases.map((caseItem, index) => (
                            <SearchResult
                                key={caseItem.id}
                                caseResult={caseItem}
                                resultIndex={index}
                            />
                        ))}
                    </Fragment>
                )}
            </Flex>
        </Card>
    );
});
